import {
  PricingPackResponse,
  PricingResponse,
} from '../../../services/pricing';
import { PropElementRequest } from '../../../services/proposal';
import moment from 'moment';
import { pricingStepToElementStep } from './pricingStepToElementStep';
import { pricingAttributeToElementAttribute } from './pricingAttributeToElementAttribute';
import _ from 'lodash';
export function pricingToElement(
  offer: PricingPackResponse,
  pricing: PricingResponse,
  investamount: number,
  vatamount: number,
  rvamount: number,
  rvcoef: number,
  cteid: number,
  cteidparent: number,
  schedule?: any
): PropElementRequest {
  // SERV = serviceduration ==> ctecalculationtype
  // SERV = servicecalculationmethod ==> ctecalculationbasis
  // FIN = calculationmethod ==>ctecalculationtype
  const upfront = (pricing.upfrontdefault * investamount) / 100;

  const firtspayment = (pricing.firstrentaldefault * investamount) / 100;
  if (rvamount === -1)
    rvamount = pricing.rvdefault
      ? (pricing.rvdefault * investamount) / 100
      : pricing.rvdefaultamount;
  return {
    offer: offer,
    ofrid: offer.ofrid,
    ofrlabel: offer.ofrlabel,
    ofrtype: offer.ofrtype,
    pricing: pricing,
    assetid: 0,
    conElemAssets: [],
    conElemSchedules: schedule ?? [],

    depositratetype: pricing.depositratetype,
    deferredinterestratetype: pricing.deferredinterestratetype,

    conElemAttributes: pricing.attributeList
      ? pricingAttributeToElementAttribute(pricing.attributeList)
      : [],

    conElemSteps: pricing.pricingStepList
      ? pricingStepToElementStep(pricing.pricingStepList)
      : [],

    conElemPrefinSteps: [],
    conElemServiceSteps: [],
    ctebilligdate: pricing.ctebilligdate ?? '05',
    cteactuarialrate: 0,
    ctecalculationbasis: pricing.serviceResponse?.servcalculationmethod,
    ctecalculationtype:
      pricing.ctetype === 'FIN' //|| pricing.ctetype === 'FINSERV'
        ? pricing.calculationmethod
        : pricing.serviceResponse?.servduration,
    ctecategory: pricing.ctecategory,
    ctecategorylabel: pricing.ctecategory,
    ctedeferredinterest: 0,
    ctedeferredinterestmethod: pricing.deferredinterestmethod,

    ctedepositamount: pricing.depositamount,
    ctedepositcoef: pricing.depositcoef,
    ctedepositinterest: 0,
    ctedepositinterestmethod: pricing.depositinterestmethod,
    ctedepositnominalrate:
      pricing.depositratetype === 'CONTRACT'
        ? pricing.ratespreaddefault + pricing.ratevaluedefault
        : pricing.depositnominalrate,
    ctedeferredinterestnominalrate:
      pricing.deferredinterestratetype === 'CONTRACT'
        ? pricing.ratespreaddefault + pricing.ratevaluedefault
        : pricing.deferredinterestnominalrate,

    ctedescription: pricing.prilabel,
    ctedirection: pricing.ctetype === 'COMM' ? 'OUT' : 'IN',
    cteduration: pricing.durationdefault,
    cteendamount: 0,
    cteenddate: '',
    ctefinancedamount: investamount,
    ctefirstpayment: firtspayment, //0,
    ctefirstpaymentcoef: pricing.firstrentaldefault,
    ctefirstpaymentdate: '',
    ctefree1: '',
    ctegraceperiodduration: pricing.gpduration,
    ctegraceperiodmethod: pricing.gpmethod,
    cteid: cteid === 0 ? Math.round(_.random(10000000)) : cteid,
    cteidparent: pricing.ctetype === 'FIN' ? 0 : cteidparent,
    cteinitialamount: 0,
    cteinstallmentamount: pricing.serviceResponse?.servfixedamount,
    cteinterestmethod: pricing.interestmethod,
    cteinvestamount: investamount,
    ctenominalrate:
      pricing.ctetype === 'FIN' || pricing.ctetype === 'FINSERV'
        ? pricing.ratespreaddefault + pricing.ratevaluedefault
        : pricing.serviceResponse?.servpercentage,
    cteorder: pricing.ctetype === 'FIN' ? 0 : 1,

    ctepartdays: pricing.partnbdays,
    ctepartmethod: pricing.partmethod,
    //ctepartamount: pricing.ctetype === 'FIN' ? pricing.partamount : pricing.servfixedamount,
    //ctepartrate: pricing.ctetype === 'FIN' ? pricing.partrate : pricing.serviceResponse?.servpercentage,
    ctepartamount:
      pricing.ctetype === 'FIN'
        ? pricing.partmethod === 'FIXED' || pricing.partmethod === 'REDUCEFIN'
          ? pricing.partamount
          : (pricing.partrate * investamount) / 100
        : 0,
    ctepartrate:
      pricing.ctetype === 'FIN'
        ? pricing.partmethod === 'FIXED' || pricing.partmethod === 'REDUCEFIN'
          ? (pricing.partamount / investamount) * 100
          : pricing.partrate
        : 0,
    ctepaymentterm: pricing.term,
    cteperiodicity: pricing.periodicity,
    cteratebasis: pricing.calculationbasis,
    cterateformula: pricing.rateformula,
    cterateperiodicity: String(pricing.rateperiodicity),
    cteratespread: pricing.ratespreaddefault,
    cterateterm: pricing.term,
    cteratetype: pricing.ratetype,
    cterentalamount: 0,
    ctervamount: rvamount, //pricing.rvdefaultamount,
    ctervcoef: rvcoef,
    ctestartamount: 0,
    ctestartdate: moment(),
    ctestatus: 'INIT',
    ctetype: pricing.ctetype,
    cteunit: pricing.unit,
    cteupfrontamount: pricing.ctetype === 'FIN' ? upfront : 0,
    ctrid: 0,
    currcode: localStorage.getItem('currcode') ?? '',
    last_action: '',
    rvcalculationmode: pricing.rvcalculationmode,
    rvevaluationmode: pricing.rvevaluationmode,
    prefinrateref: pricing.prefinnominalrate,
    prefinratespread: 0,
    cterateref: pricing.ratevaluedefault,
    prefinbasis: pricing.prefinbasis,
    prefinmethod: pricing.prefinmethod,
    prefinnominalrate: pricing.prefinnominalrate,
    prefinperiodicity: pricing.prefinperiodicity,
    prefinrateformula: pricing.prefinrateformula,
    prefinratetype: pricing.prefinratetype,
    priid: pricing.priid,
    taxcode: pricing.taxcode,
    taxrate: pricing.taxrate,
    taxtype: pricing.taxtype,
    tpid: 0,
    tpidparticipation: pricing.tpidparticipation,
    calculatedamountbasis: pricing.serviceResponse?.calculatedamountbasis,
    marginoncalulatedcamount: pricing.serviceResponse?.marginoncalulatedamount,
    additionalcostaftermargin:
      pricing.serviceResponse?.additionalcostaftermargin,
    servfixedamount: pricing.serviceResponse?.servfixedamount,
    servpercentage: pricing.serviceResponse?.servpercentage,

    pritype: '',

    helpers: {
      marginratemin: pricing?.marginratemin,
      margincontextmin: pricing?.margincontextmin,
      marginratemax: pricing?.marginratemax,
      margincontextmax: pricing?.margincontextmax,
      servfixedamountmin: pricing.servfixedamountmin,
      servpercentagemin: pricing.servpercentagemin,
      servcontextmin: pricing.servcontextmin,
      durationmax: pricing.durationmax ? pricing.durationmax : 120,
      durationmin: pricing.durationmin ? pricing.durationmin : 0,
      //durationdefault: pricing.durationdefault ? pricing.durationdefault : 0,
      frmin: pricing.firstrentalmin ? pricing.firstrentalmin : 0,
      frmax: pricing.firstrentalmax ? pricing.firstrentalmax : 0,
      upmax: pricing.upfrontmax ? pricing.upfrontmax : 0,
      upmin: pricing.upfrontmin ? pricing.upfrontmin : 0,

      rvmax:
        pricing.rvevaluationmode === 'FIXED'
          ? (Number(rvamount) / investamount) * 100
          : pricing.rvmax
          ? pricing.rvmax
          : 50,
      rvmin:
        pricing.rvevaluationmode === 'FIXED'
          ? (Number(rvamount) / investamount) * 100
          : pricing.rvmin
          ? pricing.rvmin
          : 0,
      rvcontextmax:
        pricing.rvevaluationmode === 'FIXED'
          ? (Number(rvamount) / investamount) * 100
          : pricing.rvcontextmax
          ? pricing.rvcontextmax
          : 50,
      rvcontextmin:
        pricing.rvevaluationmode === 'FIXED'
          ? (Number(rvamount) / investamount) * 100
          : pricing.rvcontextmin
          ? pricing.rvcontextmin
          : 0,

      ratecontextmin: pricing.ratevaluedefault + pricing.ratecontextmin,
      ratecontextmax: pricing.ratevaluedefault + pricing.ratecontextmax,

      frcontextmax: pricing.frcontextmax,
      frcontextmin: pricing.frcontextmin,

      durationcontextmax: pricing.durationcontextmax,
      durationcontextmin: pricing.durationcontextmin,

      gpdurationmax: pricing.gpduration ? pricing.gpduration : 0,
      ratemax:
        pricing.ratevaluedefault != null
          ? pricing.ratevaluedefault + pricing.ratespreadmax
          : 30,
      ratemin:
        pricing.ratevaluedefault != null
          ? pricing.ratevaluedefault + pricing.ratespreadmin
          : 1,
      gpmin: pricing.gpmin ?? 0,
      gpmax: pricing.gpmax ?? 15,
    },
    spvassetdiscount: pricing.spvassetdiscount,
    spvriskrate: pricing.spvriskrate,
    spvadditionalfees: pricing.spvadditionalfees,
    spvloancoef: pricing.spvloancoef,
    spvdiscountsale: pricing.spvdiscountsale,
    spvinflation: pricing.spvinflation,
    spvassetdiscountamount: 0,
    spvloanamount: 0,
    spvriskamount: 0,
    spvfeesamount: 0,
    servbasis: pricing?.serviceResponse?.servfreebasisdefault ?? 0,
    serviceResponse: pricing.serviceResponse,
    servtype: pricing.serviceResponse?.servtype,
    serviceStepList: pricing.serviceStepList,
    pricingStepList: pricing.pricingStepList,
    commissionResponse: pricing.commissionResponse,
    rvauthid: pricing.rvauthid,
    rvtaskid: pricing.rvtaskid,
    rateauthid: pricing.rateauthid,
    ratetaskid: pricing.ratetaskid,
    frauthid: pricing.frauthid,
    frtaskid: pricing.frtaskid,
    durationauthid: pricing.durationauthid,
    durationtaskid: pricing.durationtaskid,
    servtaskid: pricing.servtaskid,
    servauthid: pricing.servauthid,
    margintaskid: pricing.margintaskid,
    marginauthid: pricing.marginauthid,
    ctefeesamount: 0,
    ctecommissionamount: 0,
    cteprofitabilityrate: 0,
    cteaprrate: 0,
    cteflatrate: 0,
    ctecoefrate: 0,
    ctefundingrate: 0,
    ctefundingperiodicity: 0,
    ctefundinginstallment: 0,
    ctefundingcost: 0,
    ctemarginamount: 0,
    ctemarginrate: 0,
    ctevatdeferralamount: vatamount,
    ctevatdeferralduration: 0,
    ctevatdeferralmethod: 'NONE',
    ctevatdeferraldaysbasis: '365',
    cteextracosttofinance: 0,
    cteextracostcomment: '',
    ctemileage: 0,
    ctepriidexceed: 0,
    totalInterest: 0,
    totalRental: 0,
    totalAmortization: 0,
    totaldiscountedInterest: 0,
    totalVatDeffered: 0,
    totaldiscountedOutstanding: 0,
    totaldiscountedAgiosdeb: 0,
    totalAgiosdeb: 0,
    marginImpactCredit: 0,
    marginImpactDebit: 0,
    dgo: 0,
    profitabilityAmount: 0,
    ceilingrate: 0,
    ceilingdefaultrate: 0,
    floorrate: 0,
    floordefaultrate: 0,
    calid: 0,
    ctepartratetype: pricing.partratetype,
    ctepartrateformula: pricing.partrateformula,
    ctepartinvoicingmode: pricing.partinvoicingmode,
    servdescription: '',
    servusecoverage: pricing.serviceResponse?.servusecoverage,
    servusedeductionamount: pricing.serviceResponse?.servusedeductionamount,
    servusedeductionpercenrage:
      pricing.serviceResponse?.servusedeductionpercenrage,
    servusefrequency: pricing.serviceResponse?.servusefrequency,
    servusemaxamount: pricing.serviceResponse?.servusemaxamount,
    servuseminamount: pricing.serviceResponse?.servuseminamount,
    servuseqty: pricing.serviceResponse?.servuseqty,
    servuseunit: pricing.serviceResponse?.servuseunit,
  };
}
